import React from 'react';
import AuthProvider from './auth/AuthProvider';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppLayout, Box } from '@amzn/awsui-components-react';
import TopNav from './components/Layout/TopNav';
import SideNav from './components/Layout/SideNav';
import AppRoutes from './components/Layout/AppRoutes';

const AppContent: React.FC = () => {
  return (
    <Box>
      <TopNav />
      <AppLayout
        navigation={<SideNav />}
        content={<AppRoutes />}
        toolsHide
        navigationHide={false}
      />
    </Box>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
          <AppContent />
      </Router>
    </AuthProvider>
  );
};

export default App;
